'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var timezone_moment = require('moment-timezone');
var _ = require('lodash');
function RecommendationEntryService(FaresOptimizerConstants, momentService, configurationService) {
  function getApprovalCount(data, level, isOnlyApprover) {
    var count = 0;
    _.forEach(data, function (group) {
      if (isFootnoteDatesValid(group)) {
        if (group.status === FaresOptimizerConstants.NEW && (level === FaresOptimizerConstants.INTERMEDIATE || level === FaresOptimizerConstants.FINAL && isOnlyApprover)) {
          count++;
        } else if (group.status === FaresOptimizerConstants.PENDING && level === FaresOptimizerConstants.FINAL) {
          count++;
        }
      }
    });
    return count;
  }
  function getRejectionCount(data, level, isOnlyApprover) {
    var count = 0;
    _.forEach(data, function (group) {
      if (group.status === FaresOptimizerConstants.NEW && (level === FaresOptimizerConstants.INTERMEDIATE || level === FaresOptimizerConstants.FINAL && isOnlyApprover)) {
        count++;
      } else if (group.status === FaresOptimizerConstants.PENDING && level === FaresOptimizerConstants.FINAL || approvedLadderRejectable(group, level)) {
        count++;
      }
    });
    return count;
  }
  function approvedLadderRejectable(group, level) {
    return ladderWithApprovalDateInFuture(group) && level === FaresOptimizerConstants.FINAL;
  }
  function ladderWithApprovalDateInFuture(group) {
    return group.status === FaresOptimizerConstants.APPROVED && isRecommendationEffectiveDateAfterCurrentDate(group.recommendationEffectiveDate);
  }
  function isRecommendationEffectiveDateAfterCurrentDate(value) {
    if (!value) {
      return false;
    }
    var currentDate = momentService.now(value.config);
    return value.isAfter(currentDate, 'day');
  }
  function convertTimeStampToATPCOTimezone(timeStamp) {
    return timezone_moment(new Date(timeStamp)).tz(configurationService.getATPCOTimeZone());
  }
  function isFootnoteDatesValid(ladder) {
    if (ladder.category === 'STRUCTURAL') {
      return true;
    }
    var currentTimeStamp = momentService.of(momentService.now(momentService.FIELD.TRAVEL_DATE), momentService.TYPE.LOCAL_DATE);
    var currentATPCOTimeStamp = convertTimeStampToATPCOTimezone(currentTimeStamp.clone().value);
    var currentATPCOTimeStampPlusOneDay = convertTimeStampToATPCOTimezone(currentTimeStamp.clone().setDay(currentTimeStamp.day() + 1).value);
    var currentATPCOTimeStampPlusOneYear = convertTimeStampToATPCOTimezone(currentTimeStamp.clone().setYear(currentTimeStamp.year() + 1).value);
    if (shouldPerformFootnoteCheck(ladder)) {
      return performFootnoteValidation(ladder, currentATPCOTimeStamp, currentATPCOTimeStampPlusOneDay, currentATPCOTimeStampPlusOneYear);
    }
    return true;
  }
  function shouldPerformFootnoteCheck(ladder) {
    return ladder.actionCode === 'C' || ladder.actionCode === 'N' || !_.isUndefined(ladder.isFootnoteUpdated) && ladder.isFootnoteUpdated;
  }
  function performFootnoteValidation(ladder, currentATPCOTimeStamp, currentATPCOTimeStampPlusOneDay, currentATPCOTimeStampPlusOneYear) {
    if (isFootnoteDatesDefined(ladder, 'outboundTravelDates') && isTravelDatesValid(ladder, 'outboundTravelDates', currentATPCOTimeStamp, currentATPCOTimeStampPlusOneYear)) {
      return false;
    }
    if (isFootnoteDatesDefined(ladder, 'inboundTravelDates') && isTravelDatesValid(ladder, 'inboundTravelDates', currentATPCOTimeStamp, currentATPCOTimeStampPlusOneYear)) {
      return false;
    }
    if (isFootnoteDatesDefined(ladder, 'ticketingDates') && isDatesValid(ladder, 'ticketingDates', currentATPCOTimeStampPlusOneYear, currentATPCOTimeStampPlusOneDay)) {
      return false;
    }
    return !(isFootnoteDatesDefined(ladder, 'reservationDates') && isDatesValid(ladder, 'reservationDates', currentATPCOTimeStampPlusOneYear, currentATPCOTimeStamp));
  }
  function isFootnoteDatesDefined(ladder, fieldName) {
    return !isFootnoteDatesNullOrUndefined(ladder, fieldName) || !isUserAdjustmentUndefined(ladder) && !isUserAdjustedDatesNullOrUndefined(ladder, fieldName);
  }
  function isTravelDatesValid(ladder, fieldName, currentATPCOTimeStamp, currentATPCOTimeStampPlusOneYear) {
    return isAfterDate(getEarliestDateInATPCOTimezone(ladder, fieldName, 'from'), currentATPCOTimeStampPlusOneYear) || isSameDate(getEarliestDateInATPCOTimezone(ladder, fieldName, 'from'), currentATPCOTimeStampPlusOneYear) || isPreviousDate(getLatestDateInATPCOTimezone(ladder, fieldName, 'to'), currentATPCOTimeStamp) || isPreviousDate(getLatestDateInATPCOTimezone(ladder, fieldName, 'complete'), currentATPCOTimeStamp);
  }
  function isDatesValid(ladder, fieldName, beginDateCheck, endDateCheck) {
    return isAfterDate(getEarliestDateInATPCOTimezone(ladder, fieldName, 'begin'), beginDateCheck) || isSameDate(getEarliestDateInATPCOTimezone(ladder, fieldName, 'begin'), beginDateCheck) || isPreviousDate(getLatestDateInATPCOTimezone(ladder, fieldName, 'end'), endDateCheck);
  }
  function isCurrentRecommendationInProcess(data, selectedLadder) {
    var matchingLadders = _.filter(data, {
      'fareRecommendationRecordKey': selectedLadder.fareRecommendationRecordKey
    });
    var inProcessLadderExists = false;
    if (matchingLadders.length > 1) {
      _.forEach(matchingLadders, function (ladder) {
        if (!ladder.isExpired) {
          inProcessLadderExists = ladder.status === FaresOptimizerConstants.FILED || ladder.status === FaresOptimizerConstants.UNDO_INITIATED || ladder.status === FaresOptimizerConstants.UNDO_FILED;
        }
      });
    }
    return inProcessLadderExists;
  }
  function getUndoCount(data, level, rowGroup) {
    var count = 0;
    _.forEach(data, function (group) {
      if (!group.hasTargetFaresDiscontinued && !group.hasSharedFbc && !group.allFaresCancelled && (group.status === FaresOptimizerConstants.VALIDATED || group.status === FaresOptimizerConstants.FILED && group.category === 'TACTICAL') && !isCurrentRecommendationInProcess(rowGroup, group) && (level === FaresOptimizerConstants.INTERMEDIATE || level === FaresOptimizerConstants.FINAL)) {
        count++;
      }
    });
    return count;
  }
  function getLadderByMaxEffectiveDate(data) {
    return _.chain(data).without(undefined).maxBy('recommendationEffectiveDate').value();
  }
  function isUserAdjustmentUndefined(recommendationLadder) {
    return _.isUndefined(recommendationLadder.userAdjustedDates) || _.isNil(recommendationLadder.userAdjustedDates);
  }
  function isFootnoteDatesNullOrUndefined(recommendationLadder, fieldName) {
    return _.isUndefined(recommendationLadder[fieldName]) || _.isNil(recommendationLadder[fieldName]);
  }
  function isUserAdjustedDatesNullOrUndefined(recommendationLadder, fieldName) {
    return _.isUndefined(recommendationLadder.userAdjustedDates) || _.isNil(recommendationLadder.userAdjustedDates) || _.isUndefined(recommendationLadder.userAdjustedDates[fieldName]) || _.isNil(recommendationLadder.userAdjustedDates[fieldName]);
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : momentService.of(date, momentService.TYPE.LOCAL_DATE);
  }
  function isSameDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isSame(date2);
    }
    return false;
  }
  function isPreviousDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isBefore(date2);
    }
    return false;
  }
  function isAfterDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isAfter(date2);
    }
    return false;
  }
  function getFilteredRecommendation(data) {
    var recommendation = _.filter(data.groupedRows, function (row) {
      return !(row.actionCode === 'X' || row.fbc === data.hostHighestFbc || isUnmappedRBD(row));
    });
    return recommendation;
  }
  function getDateList(row, fieldName, dateList) {
    if (!isUserAdjustmentUndefined(row)) {
      if (!isUserAdjustedDatesNullOrUndefined(row, fieldName)) {
        dateList = row.userAdjustedDates[fieldName];
      }
    } else {
      dateList = row[fieldName];
    }
    return dateList;
  }
  function getEarliestDate(data, fieldName, dateFieldName) {
    var dateList;
    var dateInRbd;
    var recommendation = getFilteredRecommendation(data);
    _.forEach(recommendation, function (row) {
      var earliestDate;
      dateList = getDateList(row, fieldName, dateList);
      _.each(dateList, function (element) {
        if (!earliestDate || isPreviousDate(element[dateFieldName], earliestDate)) {
          earliestDate = element[dateFieldName];
        }
      });
      if (!dateInRbd || isAfterDate(earliestDate, dateInRbd)) {
        dateInRbd = earliestDate;
      }
    });
    return dateInRbd;
  }
  function getLatestDate(data, fieldName, dateFieldName) {
    var dateList;
    var dateInRbd;
    var recommendation = getFilteredRecommendation(data);
    _.forEach(recommendation, function (row) {
      var latestDate;
      dateList = getDateList(row, fieldName, dateList);
      _.each(dateList, function (element) {
        if (!latestDate || isAfterDate(element[dateFieldName], latestDate)) {
          latestDate = element[dateFieldName];
        }
      });
      if (!dateInRbd || isPreviousDate(latestDate, dateInRbd)) {
        dateInRbd = latestDate;
      }
    });
    return dateInRbd;
  }
  function isUnmappedRBD(row) {
    return _.isUndefined(row.selectedCompetitorKey) || _.isNil(row.selectedCompetitorKey);
  }
  function getLatestDateInATPCOTimezone(data, fieldName, dataFieldName) {
    var latestDate = getLatestDate(data, fieldName, dataFieldName);
    if (!_.isUndefined(latestDate)) {
      return convertTimeStampToATPCOTimezone(getMomentType(latestDate).clone().value);
    }
    return latestDate;
  }
  function getEarliestDateInATPCOTimezone(data, fieldName, dataFieldName) {
    var earliestDate = getEarliestDate(data, fieldName, dataFieldName);
    if (!_.isUndefined(earliestDate)) {
      return convertTimeStampToATPCOTimezone(getMomentType(earliestDate).clone().value);
    }
    return earliestDate;
  }
  function getMinimumOfTravelAndReservationDates(ladder) {
    return _.chain([getLatestDateInATPCOTimezone(ladder, 'outboundTravelDates', 'to'), getLatestDateInATPCOTimezone(ladder, 'outboundTravelDates', 'complete'), getLatestDateInATPCOTimezone(ladder, 'inboundTravelDates', 'to'), getLatestDateInATPCOTimezone(ladder, 'inboundTravelDates', 'complete'), getLatestDateInATPCOTimezone(ladder, 'ticketingDates', 'end'), getLatestDateInATPCOTimezone(ladder, 'reservationDates', 'end')]).filter(filterNotNull).map(getDateInUserTimezone).min().value();
  }
  function filterNotNull(date) {
    return !_.isNil(date);
  }
  function getDateInUserTimezone(momentDate) {
    return momentService.of(momentDate, momentService.TYPE.LOCAL_DATE);
  }
  return {
    getApprovalCount: getApprovalCount,
    getRejectionCount: getRejectionCount,
    getLadderByMaxEffectiveDate: getLadderByMaxEffectiveDate,
    getUndoCount: getUndoCount,
    isCurrentRecommendationInProcess: isCurrentRecommendationInProcess,
    isFootnoteDatesValid: isFootnoteDatesValid,
    ladderWithApprovalDateInFuture: ladderWithApprovalDateInFuture,
    getMinimumOfTravelAndReservationDates: getMinimumOfTravelAndReservationDates
  };
}
RecommendationEntryService.$inject = ['FaresOptimizerConstants', 'MomentService', 'ConfigurationService'];
module.exports = RecommendationEntryService;